import { Injectable } from '@angular/core';
import { Inject } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { ConfigService} from './config.service';
import { TokenInterface, TokenInterfaceAPI } from '../..';
import { catchError } from 'rxjs/operators';
import {BasicResponse} from '@auth-suite-services/services';

@Injectable({
  providedIn: 'root'
})
export class TokensService {

  private URL;
  headers: HttpHeaders;

  constructor(@Inject(ConfigService) private config: any, private httpClient: HttpClient) {
    this.URL = config.REST_SERVER_HOST + config.REST_SERVER_url.find((restUrl: any) => restUrl.api === 'SDSETUP').url;
    this.headers = new HttpHeaders().set('DoNotIntercept', 'true');
  }

  getAllToken(pageIndex: number, pageSize: number, sortActive: string, sort: string): Observable<TokenInterfaceAPI> {
    console.log('PageIndex; PageSize; SortActive; Sort');
    console.log(pageIndex, pageSize, sortActive, sort);
    const headers = this.headers;
    // tslint:disable-next-line:max-line-length
    return this.httpClient.get<TokenInterfaceAPI>(`${this.URL}/tok/getalltokens/${pageIndex}/${pageSize}/${sortActive ? sortActive : 'id'}/${sort ? sort : 'asc'}`, {headers}).pipe(catchError(this.handleError));
  }

  getToken(id: number): Observable<TokenInterface> {
    console.log('PageIndex; PageSize; SortActive; Sort');
    console.log(id);
    const headers = this.headers;
    return this.httpClient.get<TokenInterface>(`${this.URL}/tok/gettoken/${id}`, {headers}).pipe(catchError(this.handleError));
  }

  updateTOK(tok: TokenInterface): Observable<BasicResponse> {
    const headers = this.headers;
    console.log('Update tok: ' + JSON.stringify(tok));
    return this.httpClient.post<BasicResponse>(`${this.URL}/tok/updatetoken`, tok, {headers}).pipe(catchError(this.handleError));
  }

  createTOK(tok: TokenInterface): Observable<BasicResponse> {
    const headers = this.headers;
    console.log('Update tok: ' + JSON.stringify(tok));
    return this.httpClient.post<BasicResponse>(`${this.URL}/tok/createtoken`, tok, {headers}).pipe(catchError(this.handleError));
  }

  //added call to set status                                            21/11/23 CN
  setTokenStatus(id: {id: number}): Observable<BasicResponse> {
    console.log("======================================================================");
    console.log(id.id);
    console.log("======================================================================");
    const headers = this.headers;
    return this.httpClient.post<BasicResponse>(`${this.URL}/tok/settokenstatus/${id.id}`, {headers}).pipe(catchError(this.handleError));
  }

  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      console.error(
          `Backend returned code ${error.status}, ` + `body was: ${error.error}`
      );
    }
    // return an observable with a user-facing error message
    // return throwError('Something bad happened; please try again later.');
    return throwError(error);
  }
}
